import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { fadeEllipsis } from 'styles-js/mixins/fade';
import { LinkButton, TagLink } from 'styles-js/buttons';
type Props = {
  tags: tag[];
  hasLink?: boolean;
  username?: string;
  onMoreClick?: (href: string, username: string) => void;
};
type tag = {
  entityName?: string;
  id?: number;
  name: string;
};
export default function MemberCardTags({
  tags,
  hasLink = false,
  username = undefined,
  onMoreClick
}: Props) {
  return <Container hasLink={hasLink} hasOnClick={!!onMoreClick} data-sentry-element="Container" data-sentry-component="MemberCardTags" data-sentry-source-file="memberCardTags.tsx">
      {tags?.map(tag => {
      const name = tag.entityName || tag.name;
      return <TagLink as="li" key={tag.id || name}>
            {name}
          </TagLink>;
    })}
      {(hasLink || !!onMoreClick) && <li>
          <SeeMore visible={!!tags?.length}>
            <LinkButton onClick={() => {
          if (username && onMoreClick) onMoreClick(`/user/${username}`, username);
        }}>
              {i18n.t('See more')}
            </LinkButton>
          </SeeMore>
        </li>}
    </Container>;
}
const Container = styled.ul<{
  hasLink?: boolean;
  hasOnClick?: boolean;
}>`
  position: relative;
  height: 60px;
  overflow: hidden;
  list-style: none;
  margin: 0;
  padding: 0;

  ::after {
    ${fadeEllipsis};
    height: 28px;
    right: ${props => props.hasLink || props.hasOnClick ? '50px' : '0'};
  }
`;
const SeeMore = styled.span<{
  visible: boolean;
}>`
  visibility: ${props => props.visible ? 'visible' : 'hidden'};
  position: absolute;
  bottom: 0;
  right: 0;
  padding-top: 3px;
  padding-left: 15px;
  z-index: 1;
  background-color: ${({
  theme
}) => theme.colorWhite};
  color: ${({
  theme
}) => theme.colorBlue};
  line-height: ${({
  theme
}) => theme.fontLineHeightM};
`;